import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconWarning({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd'>
                <g>
                    <circle stroke={color} strokeWidth='2' cx='12' cy='12' r='9' />
                    <g transform='matrix(1 0 0 -1 11 17)' fill={color}>
                        <rect y='3' width='2' height='7' rx='1' />
                        <rect width='2' height='2' rx='1' />
                    </g>
                </g>
            </g>
        </svg>
    );
}
